// extracted by css-extract-rspack-plugin
export default {"LabelColorIndicator":"repository-filter-actions-module__LabelColorIndicator__GTUpE"};